import * as views from "../views";
import EmptyView from "@/core/components/EmptyView.vue";
export default [
  {
    path: "dashboard",
    component: EmptyView,
    children: [
      {
        path: "",
        name: "Dashboard",
        component: views.Dashboard,
        meta: {
          headerVisible: true,
          // headerTitle: "Hello, Gempages",
          // headerDomain: null,
        }
      },
      {
        path: "templates",
        name: "Templates",
        component: views.TemplatesList,
        meta: {
          headerVisible: false,
          // headerDomain: null,
        }
      },
    ]
  }
];
